import React, { useContext } from "react"
import { StyleSheet, View } from "react-native"
import { ThemeContext } from "../utility/context/ThemeContext"
import { SkeletonBlock, SkeletonGroup, SkeletonLine } from "../utility/skeleton"
import useScreenSize from "../utility/screen-size"
import { MAX_CONTENT_WIDTH } from "../config"

export const ExploreFeaturedTagsSkeleton = ({
  sectionCount = 2,
  cardsPerSection = 8,
}: {
  sectionCount?: number
  cardsPerSection?: number
  cardWidth?: number
}): React.ReactElement => {
  const { theme } = useContext(ThemeContext)
  const { bgMain } = theme.colors

  const screenWidth = useScreenSize().width

  const clampedSections = Math.max(1, Math.min(4, sectionCount))
  const clampedCards = Math.max(2, Math.min(6, cardsPerSection))

  // width is min between screenwidth and cardWidth
  const width = Math.min(screenWidth, MAX_CONTENT_WIDTH)

  return (
    <View style={[styles.container, { backgroundColor: bgMain }]}>
      <SkeletonGroup>
        {new Array(clampedSections).fill(0).map((_, sIdx) => (
          <View key={sIdx} style={{ gap: 10, marginBottom: 18 }}>
            {/* Banner */}
            <SkeletonLine width="100%" height={width * (2/5)} radius={8} />
            {/* Header */}
            <SkeletonLine width="55%" height={14} radius={8} />
            {/* Subtext */}
            <SkeletonLine width="70%" height={12} radius={8} />

            {/* Horizontal chips/cards */}
            <View style={styles.row}>
              {new Array(clampedCards).fill(0).map((__, cIdx) => (
                <View key={cIdx} style={[styles.card]}>
                  <SkeletonBlock style={styles.logo} radius={10} />
                  <View style={{ width: "100%", gap: 8, justifyContent: "center", alignItems: "center" }}>
                    <SkeletonLine width="100%" height={14} radius={6} />
                    <SkeletonLine width="100%" height={14} radius={6} />
                  </View>
                </View>
              ))}
            </View>
          </View>
        ))}
      </SkeletonGroup>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    paddingTop: 20,
    paddingHorizontal: 16,
  },
  row: {
    flexDirection: "row",
    gap: 10,
    overflow: "hidden",
  },
  card: {
    padding: 12,
    flexDirection: "column",
    gap: 10,
    justifyContent: "center",
    alignItems: "center",
  },
  logo: {
    width: 100,
    height: 100,
  },
})

